import React, { Component } from 'react';


class ContactPage extends Component {
  state = {
    name: '',
    email: '',
    message: ''
  };

  handleChangeName = (e) => this.setState({name: e.target.value});
  handleChangeEmail = (e) => this.setState({email: e.target.value});
  handleChangeMessage = (e) => this.setState({message: e.target.value});

  render() {
    return (
      <div style={{padding: 20}}>
        <h1>Contact Us</h1>

         <p>
         If you have business inquiries or other questions, please fill out the following form to contact us. Alternatively you can call 07866 432026 (Mobile) or 01904 793538 (Home)
         Thank you.
         </p>

         <div className="form">

         <form method="post" className="activeForm">
          <p className="note">All fields are required.</p>

          <div className="row">
            <label>Name</label>
            <input name="name" value={this.state.name} onChange={this.handleChangeName} />
          </div>

          <div className="row">
            <label>Email</label>
            <input name="email" type="email" value={this.state.email} onChange={this.handleChangeEmail} />
          </div>


          <div className="row">
            <label>Message</label>
            <textarea rows="6" cols="50" name="message" value={this.state.message} onChange={this.handleChangeMessage} />
          </div>



          <div className="row buttons">
            <button type="submit">Send</button>
          </div>

         </form>

         </div>
      </div>
    );
  }
}

export default ContactPage;




/** WEBPACK FOOTER **
 ** ./src/ContactPage.js
 **/